import { forwardRef, type HTMLAttributes } from "react";

import styles from "./container.module.css";
import { cx } from "./cx";

type Size = "sm" | "md" | "lg" | "full";

export interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  size?: Size;
}

export const Container = forwardRef<HTMLDivElement, ContainerProps>(
  ({ className, size = "lg", ...props }, ref) => (
    <div
      ref={ref}
      className={cx(styles.container, styles[size], className)}
      {...props}
    />
  ),
);

Container.displayName = "Container";
